<template>
  <v-row v-if="loaded">
    <div
      v-for="(element, index) in elements"
      :key="index"
      style="display: contents;"
      v-show="element.actualHidden === false"
    >
      <div v-if="element.value === 'projects_queues_campaigns'" style="display: contents;">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <ProjectSelector
            v-model="filters.projects"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <Campaign-Selector
            v-model="filters.campaigns"
            no-rules
            :projectIds="filters.projects"
            :disabled.sync="disableCampaignSelector"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <Queue-Selector
            v-model="filters.queues"
            no-rules
            :projectIds="filters.projects"
          />
        </v-col>
      </div>

      <div v-if="element.value === 'projects_queues'" style="display: contents;">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <ProjectSelector
            v-model="filters.projects"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <Queue-Selector
            v-model="filters.queues"
            no-rules
            :projectIds="filters.projects"
          />
        </v-col>
      </div>

      <div v-if="element.value === 'helpers_forms'" style="display: contents;">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <HelperSelector v-model="filters.helpers" @change:forms="fillFormsForCombinedSelector" />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <FormSelector v-model="filters.forms" :associated="formsItems" />
        </v-col>
      </div>

      <div v-if="element.value === 'helpers_queues_forms'" style="display: contents;">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <HelperSelector v-model="filters.helpers" @change:forms="fillFormsForCombinedSelector" @change:queues="fillQueuesForCombinedSelector" />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <QueueSelector v-model="filters.queues" :helpersIds="queuesItems" dontLinkToProject noRules />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <FormSelector v-model="filters.forms" :associated="formsItems" />
        </v-col>
      </div>

      <div v-if="element.value === 'projects_campaigns'" style="display: contents;">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <ProjectSelector
            v-model="filters.projects"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
          <Campaign-Selector
            v-model="filters.campaigns"
            no-rules
            :projectIds="filters.projects"
            :disabled.sync="disableCampaignSelector"
          />
        </v-col>
      </div>

      <v-col
        v-if="!['projects_queues_campaigns', 'helpers_forms', 'helpers_queues_forms', 'projects_campaigns', 'projects_queues'].includes(element.value)"
        cols="12" sm="6" md="4" lg="3" xl="2"
      >
        <TimeInterval
          v-if="element.value === 'time_interval'"
          v-model="filters[element.field_name]"
        />
        <TimeIntervalWithExcludes
          v-if="element.value === 'time_interval_with_excludes_and_period_selections'"
          v-model="filters.period"
          :excluded="filters.excluded_dates"
        />
        <ProjectSelector
          v-if="element.value === 'projects'"
          v-model="filters[element.field_name]"
        />
        <UserSelector
          v-if="element.value === 'users'"
          v-model="filters[element.field_name]"
          no-rules
        />
        <GroupSelector
          v-if="element.value === 'groups'"
          v-model="filters[element.field_name]"
          @change:users="fillUsers"
          :reload-agents="reloadAgentsForGroups"
          noRules
        />
        <Dictionaries
          v-if="element.value === 'dictionaries'"
          v-model="filters[element.field_name]"
          :label="element.title"
          multiple
        />
        <CustomSelect
          v-if="element.value === 'call_statuses'"
          :label="element.title"
          v-model="filters[element.field_name]"
          :items="call_statuses"
          itemText="label"
          chipText="label"
          itemValue="value"
          multiple
        />
        <CustomSelect
          v-if="element.value === 'additional'"
          :label="element.title"
          v-model="filters[element.field_name]"
          :items="extraOptions"
          multiple
        />
        <CustomSelect
          v-if="element.value === 'additional_for_customers'"
          :label="element.title"
          v-model="filters[element.field_name]"
          :items="extraOptionsForCustomer"
          multiple
        />
        <div v-if="element.value === 'duration'">
          <v-row class="mt-0 pl-3">
            <span>{{ element.title }} (сек.)</span>
          </v-row>
          <v-row no-gutters class="mt-n6">
            <v-col cols="6" class="pr-2">
              <v-text-field
                v-model.number="filters[element.field_name].from"
                hide-details
                single-line
                prefix="От"
                type="number"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.number="filters[element.field_name].to"
                hide-details
                single-line
                prefix="До"
                type="number"
              />
            </v-col>
          </v-row>
        </div>
        <CustomSelect
          v-if="element.value === 'queues'"
          :label="element.title"
          item-value="name"
          v-model="filters[element.field_name]"
          :items="getFilteredQueues()"
          selected-all
          multiple
        />
        <v-text-field
          v-if="element.value === 'input'"
          v-model="filters[element.field_name]"
          :label="element.title"
          clearable
        />
        <v-text-field
          v-if="element.value === 'search_phrase'"
          v-model="filters[element.field_name].phrase"
          :label="element.title"
          clearable
          :rules="formRules.required"
        />
        <v-container v-if="element.value === 'search_phrase'">
          <v-row>
            <v-checkbox
              v-model="filters[element.field_name].who_said"
              :rules="[(v) => !!v || filters[element.field_name].is_agent || 'Выберите']"
              prepend-icon="mdi-face"
              hide-details
              value="client"
              multiple
              title="Клиент"
            />
            <v-checkbox
              class="ml-5"
              v-model="filters[element.field_name].who_said"
              :rules="[(v) => !!v || filters[element.field_name].is_client || 'Выберите']"
              prepend-icon="mdi-face-agent"
              hide-details
              value="agent"
              multiple
              title="Агент"
            />
          </v-row>
        </v-container>
        <HelperSelector
          v-if="element.value === 'helpers'"
          v-model="filters[element.field_name]"
          @change:forms="fillForms"
        />
        <FormSelector
          v-if="element.value === 'forms'"
          v-model="filters[element.field_name]"
        />
        <CallsType
          v-if="element.value === 'calls_type'"
          v-model="filters[element.field_name]"
          :label="element.title"
        />
        <Hours
          v-if="element.value === 'hours'"
          v-model="filters[element.field_name]"
          :label="element.title"
        />
        <Days
          v-if="element.value === 'days'"
          v-model="filters[element.field_name]"
          :label="element.title"
        />
        <Campaign-Selector
          v-if="element.value === 'campaigns'"
          v-model="filters[element.field_name]"
          no-rules
          :projectIds="filters.projects"
        />
        <!-- <Queue-Selector
          v-if="element.value === 'queues'"
          v-model="filters[element.field_name]"
          no-rules
          :projectIds="filters.projects"
        /> -->

        <CaruselButton
          v-if="element.value === 'period_type'"
          label="По дате"
          type="general"
          :items="[
            {name: 'Карточки', id: 'card'},
            {name: 'Звонка', id: 'call'},
          ]"
          :getVal="getValPeriodType"
          style="margin-top:17px;"
        />
      </v-col>
    </div>

    <!-- Кнопка "Показать/Спрятать все фильтры" появляется ТОЛЬКО если есть хоть один скрытый элемент -->
    <v-col v-if="showMoreFiltersBtn" align="right">
      <v-btn plain class="mt-2" @click="showAllFilters">
        <span v-if="allFiltersShown === false">фильтры <v-icon>mdi-chevron-down</v-icon></span>
        <span v-else>фильтры <v-icon>mdi-chevron-up</v-icon></span>
      </v-btn>
    </v-col>

    <v-col v-if="searchRow" cols="12" sm="12" md="4" lg="12" align="right" class="mt-auto">
      <v-btn
        v-if="withExcel"
        color="info"
        class="mt-3 mr-1"
        :disabled="excelLoading"
        :value="true"
        @click="submitForm(true, $event)"
      >
        <v-progress-circular
          v-if="excelLoading"
          indeterminate
          color="success"
        />
        <span v-else>Excel</span>
      </v-btn>
      <v-btn v-if="feedBtn" color="success" class="mt-3 mr-1" id="rep_btn" @click="showFeed">Лента</v-btn>
      <v-btn color="success" class="mt-3" id="rep_btn" @click="submitForm()">Поиск</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { requiredRule } from '~/plugins/rules'
import TimeInterval from './TimeInterval'
import Dictionaries from './Dictionaries'
import CallsType from './CallsType'
import Hours from './Hours'
import Days from './Days'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector'
import UserSelector from '~/components/partials/selectors/UserSelector'
import GroupSelector from '~/components/partials/selectors/GroupSelector'
import HelperSelector from '~/components/partials/selectors/HelperSelector'
import FormSelector from '~/components/partials/selectors/FormSelector'
import CampaignSelector from '~/components/partials/selectors/CampaignSelector.vue'
import QueueSelector from '~/components/partials/selectors/QueueSelector.vue'
import TimeIntervalWithExcludes from './TimeIntervalWithExcludes.vue'

export default {
  name: 'ReportFilters',
  components: {
    TimeInterval,
    ProjectSelector,
    UserSelector,
    GroupSelector,
    HelperSelector,
    FormSelector,
    Dictionaries,
    CallsType,
    Hours,
    Days,
    CampaignSelector,
    QueueSelector,
    TimeIntervalWithExcludes,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    withExcel: {
      type: Boolean,
      default: false,
    },
    searchRow: {
      type: Boolean,
      default: true,
    },
    feedBtn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loaded: false,
      formRules: {
        valid: false,
        required: requiredRule,
      },

      elements: [],
      call_statuses: [],
      extraOptions: [
        { name: 'Только распознанные', id: 'only_recognized' },
        { name: 'Только не распознанные', id: 'only_unrecognized' },
        { name: 'Есть КЛН', id: 'only_kln' },
        { name: 'Только сброшенные', id: 'only_dropped' },
        { name: 'Перезвоны', id: 'only_сallback' },
        { name: 'С карточками', id: 'with_cards' },
        { name: 'Без карточек', id: 'without_cards' },
        { name: 'С ИИ анализом', id: 'with_ai_analyses' },
        { name: 'Без ИИ анализа', id: 'without_ai_analyses' },
        { name: 'С оценкой абонента', id: 'with_postivr' },
      ],
      extraOptionsForCustomer: [
        { name: 'Перезвоны', id: 'only_сallback' },
        { name: 'С оценкой абонента', id: 'with_postivr' },
      ],
      excelLoading: false,

      formsItems: [],
      queuesItems: [],
      showMoreFiltersBtn: false,
      allFiltersShown: true,
      disableCampaignSelector: true,
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: 'user/hasPermission',
      queuesGetter: 'projects/queues',
      filteredQueues: 'projects/filteredQueues',
      loading: 'shared/getLoading',
      meta: 'shared/meta',
      currentUser: 'user/currentUser',
    }),

    filters: {
      get() {
        return this.value
      },
      set(item) {
        this.$emit('input', item)
      },
    },

    reloadAgentsForGroups() {
      if (this.elements.find((item) => item.value === 'users') !== undefined) return true
      return false
    },
  },

  methods: {
    ...mapActions({
      getReportElements: 'reports/getReportElements',
      loadCallStatuses: 'reports_speech_analysis/loadCallStatuses',
      setLoading: 'shared/setLoading',
    }),

    setDefaultValue(fieldCode, fieldName) {
      if (this.filters[fieldName]) return

      switch (fieldCode) {
        case 'input':
          this.phone_number = '';
          break;

        case 'time_interval':
          this.$set(this.filters, fieldName, {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate(),
          })

          if (this.$route.query['period[start]'] && this.$route.query['period[end]']) {
            this.filters[fieldName].start = new Date(this.$route.query['period[start]'])
            this.filters[fieldName].end = new Date(this.$route.query['period[end]'])
          }

          break

        case 'call_statuses':
          this.$set(this.filters, fieldName, [])
          if (this.$route.query.call_status) {
            this.filters[fieldName]?.push(this.$route.query.call_status)
          } else {
            this.call_statuses.forEach((s) => {
              if (s.checked) this.filters[fieldName]?.push(s.value)
            })
          }

          break

        case 'calls_type':
          this.$set(
            this.filters,
            fieldName,
            this.$route.query.call_type === 'incoming' ? ['incoming'] : [],
          )
          break

        case 'duration':
          this.filters[fieldName] = {
            from: 0,
            to: 7200,
          }
          break

        case 'search_phrase':
          this.$set(this.filters, fieldName, {
            phrase: null,
            who_said: ['agent'],
          })

          break

        case 'projects_queues_campaigns':
          if (!('projects' in this.filters)) this.$set(this.filters, 'projects', [])
          if (!('campaigns' in this.filters)) this.$set(this.filters, 'campaigns', [])
          if (!('queues' in this.filters)) this.$set(this.filters, 'queues', [])

          break

        case 'helpers_forms':
          if (!('helpers' in this.filters)) this.$set(this.filters, 'helpers', [])
          if (!('forms' in this.filters)) this.$set(this.filters, 'forms', [])

          break

        case 'helpers_queues_forms':
          if (!('helpers' in this.filters)) this.$set(this.filters, 'helpers', [])
          if (!('queues' in this.filters)) this.$set(this.filters, 'queues', [])
          if (!('forms' in this.filters)) this.$set(this.filters, 'forms', [])

          break

        case 'projects_campaigns':
          if (!('projects' in this.filters)) this.$set(this.filters, 'projects', [])
          if (!('campaigns' in this.filters)) this.$set(this.filters, 'campaigns', [])

          break

        case 'projects_queues':
          if (!('projects' in this.filters)) this.$set(this.filters, 'projects', [])
          if (!('queues' in this.filters)) this.$set(this.filters, 'queues', [])

          break

        case 'time_interval_with_excludes_and_period_selections':
          if (!('period' in this.filters)) {
            this.$set(this.filters, 'period', {
              start: moment().startOf('day').toDate(),
              end: moment().endOf('day').toDate(),
            })

            if (this.$route.query['period[start]'] && this.$route.query['period[end]']) {
              this.filters.period.start = new Date(this.$route.query['period[start]'])
              this.filters.period.end = new Date(this.$route.query['period[end]'])
            }
          }

          if (!('excluded_dates' in this.filters)) this.$set(this.filters, 'excluded_dates', [])

          break

        default:
          this.$set(this.filters, fieldName, [])
          break
      }
    },

    fillUsers(users) {
      const usersElement = this.elements.find((item) => item.value === 'users')

      if (usersElement === undefined) return

      this.filters[usersElement.field_name] = users
    },

    fillForms(formsIds) {
      const usersElement = this.elements.find((item) => item.value === 'forms')

      if (usersElement === undefined) return

      this.filters[usersElement.field_name] = formsIds
    },

    setDefaultValues() {
      this.elements.forEach((element) => {
        this.setDefaultValue(element.value, element.field_name)
      })
    },

    submitForm(excel = false) {
      this.$emit('load-report', excel)
      this.setDefaultValues()
    },

    loadExcel() {
      this.$emit('load-excel')
      this.setDefaultValues()
    },

    getFilteredQueues() {
      const projectsElement = this.elements.find((element) => element.value === 'projects')
      if (projectsElement === undefined) return []

      return this.filteredQueues(this.filters[projectsElement['field_name']])
    },

    showFeed() {
      this.$emit('show-feed')
      this.setDefaultValues()
    },

    fillFormsForCombinedSelector(formsIds) {
      this.formsItems = formsIds
    },

    fillQueuesForCombinedSelector(queuesIds) {
      this.queuesItems = queuesIds
    },

    showAllFilters() {
      if (this.allFiltersShown) {
        for (const element of this.elements) {
          element.actualHidden = element.hidden
        }
      } else {
        for (const element of this.elements) {
          element.actualHidden = false
        }
      }

      this.allFiltersShown = !this.allFiltersShown
    },

    getValPeriodType(data) {
      this.filters.period_type = data
    },
  },

  async mounted() {
    this.setLoading(true)
    this.call_statuses = await this.loadCallStatuses()

    const elements = await this.getReportElements(this.$route.name)
    this.elements = elements
    this.setDefaultValues()

    let showFiltersBtn = false

    for (const element of this.elements) {
      // element.hidden НЕ МЕНЯЕТСЯ НИКОГДА (чтоб можно было обратно показать и спрятать)
      element.actualHidden = element.hidden
      // Если хоть один скрытый есть, то показываем кнопку
      if (element.hidden) {
        showFiltersBtn = true
        this.allFiltersShown = false
      }
    }

    this.showMoreFiltersBtn = showFiltersBtn

    this.loaded = true
    this.setLoading(false)
    this.$emit('load-by-get-params')
  },
}
</script>